import React from 'react';
import banner from '../../assets/img/pexels-earano-1683802.jpg'
import Logo from '../../components/Logo'
import ButtonLinkLightBlue from '../../components/buttons/ButtonLinkLightBlue';
import {Helmet} from "react-helmet";

const Page404 = () => {

    return (
        <section 
            style={{backgroundImage: `url(${banner})`}} 
            className='relative min-h-[100vh] bg-center bg-cover'
        >
            <Helmet>
                <title>Verify Email | 404 Not Found</title>
                <meta name="robots" content="noindex, nofollow"></meta>
            </Helmet>
            <div 
                className='absolute inset-0'
                style={{
                    background: 'linear-gradient(180deg,rgba(16, 28, 34, 0) 0%, rgba(16, 28, 34, 0.15) 46%, rgba(16, 28, 34, 0.84) 55%, rgba(16, 28, 34, 1) 64%)'
                }}
            />
            <div className='w-full max-w-[340px] absolute z-10 top-0 left-1/2 translate-x-[-50%] text-center px-4 mt-[120px] md:mt-[160px]'>
                <div className='scale-[1.4] my-5'>
                    <Logo />
                </div>
                <h1 className='text-3xl font-semibold my-5'>404 Not Found</h1>
                <p className='mt-5 mb-7 font-normal'>We couldn't find what you were looking for</p>

                <ButtonLinkLightBlue 
                    text="Go To Home Page"
                    href="/"
                />
            </div>
        </section>
    );
};

export default Page404;
